import { useContext, useState } from "react";
import UserContext from "../context/UserContext";
import CustomSpinner from "./CustomSpinner";

const LoginComponent = () => {

    const [datosIngresados, setDatosIngresados] = useState({
        user: "",
        password: ""
    })

    const [mensajeError, setMensajeError] = useState("Usuario o contraseña incorrectos");
    const [loading, setLoading] = useState(false);

    const { Login, loginError } = useContext(UserContext)

    const ClickLogin = async (e) => {

        e.preventDefault();

        if (datosIngresados.user.trim() !== ""
            && datosIngresados.password.trim() !== "") {
            setLoading(true);
            await Login(datosIngresados.user, datosIngresados.password);
            setLoading(false);
        } else {
            setMensajeError("Por favor, complete todos los campos.");
            return;
        }
    }

    return (
        <>
            {
                loading && (<CustomSpinner />)
            }
            <div className="mx-auto mt-6 w-full max-w-md rounded-2xl border border-black/10 bg-slate-50/80 p-6 shadow-2xl shadow-black/20 dark:border-white/10 dark:bg-slate-900/80">
                                <h2 className="mb-3 text-center text-2xl font-semibold">Iniciar Sesión</h2>
                                {
                                    loginError ?
                                        <div className="my-3 rounded-lg border border-rose-400/30 bg-rose-500/10 px-3 py-2 text-sm text-rose-800 dark:text-rose-200">
                                            {mensajeError}
                                        </div>
                                        :
                                        <></>
                                }
                                <form onSubmit={ClickLogin} className="space-y-3">
                                            <label className="block"><span className="sr-only">Usuario</span><input className="form-control" type="text" autoComplete="username" placeholder="Usuario"
                                                    value={datosIngresados.user}
                                                    onChange={(e) =>
                                                        setDatosIngresados({ ...datosIngresados, user: e.target.value })}
                                                    /></label>
                                                <label className="block"><span className="sr-only">Contraseña</span><input className="form-control" type="password" placeholder="Contraseña"
                                                    value={datosIngresados.password}
                                                    onChange={(e) =>
                                                        setDatosIngresados({ ...datosIngresados, password: e.target.value })}
                                                    /></label>
                                        <button className="btn btn-success mt-2 w-full" type="submit">Ingresar</button>
                                    </form>
                </div>
        </>
    )
}
export default LoginComponent